import React from 'react'
import PropTypes from 'prop-types'
import { has } from 'ramda'

import { Divider, StackView } from '@telus-uds/components-web'
import { components } from '@digital-commerce/shared-utils'
import PaymentBreakdownHeader from '../PaymentBreakdownHeader'
import MHMonthlyBill from '../MHMonthlyBill'
import {
  getBreakdownCategory,
  getPaymentBreakdownConfiguration,
  getTotalPriceByCategory
} from '../utils'
import { SubSectionContainer, HairlineDividerWrapper } from '../styles'

const PaymentBreakdownSection = ({
  totalPrices,
  isAuthenticated,
  renderHSMonthlyBill,
  renderMobilityMonthlyBill,
  dataTestId,
  cart,
  Actions
}) => {
  const { isMobility, isHS, isMH, totalPrice } = getPaymentBreakdownConfiguration(totalPrices)
  const { ShouldRender } = components

  const category = getBreakdownCategory(totalPrice)
  const hasRecurring = has('recurring')(totalPrice)
  const { recurring } = totalPrice
  const hasRecurringValues = hasRecurring && recurring.length > 0
  return (
    <>
      <StackView space={3}>
        <ShouldRender when={hasRecurringValues || !isHS}>
          <SubSectionContainer key={`section-${category}`} data-testid={`section-${category}`}>
            <PaymentBreakdownHeader
              category={category}
              isAuthenticated={isAuthenticated}
              dataTestId={dataTestId}
            />
            <ShouldRender when={Boolean(isHS)}>{renderHSMonthlyBill(totalPrice)}</ShouldRender>
            <ShouldRender when={Boolean(isMobility)}>
              {renderMobilityMonthlyBill(totalPrice)}
            </ShouldRender>
            <ShouldRender when={Boolean(isMH)}>
              <MHMonthlyBill
                cart={cart}
                isAuthenticated={isAuthenticated}
                dataTestId={dataTestId}
                hsTotalPrice={getTotalPriceByCategory('HS_TOTAL', totalPrices)}
                mobTotalPrice={getTotalPriceByCategory('MOBILITY_TOTAL', totalPrices)}
              />
            </ShouldRender>
            <HairlineDividerWrapper>
              <Divider variant={{ decorative: true }} />
            </HairlineDividerWrapper>
          </SubSectionContainer>
        </ShouldRender>
      </StackView>
      {Actions}
    </>
  )
}

PaymentBreakdownSection.propTypes = {
  totalPrices: PropTypes.array.isRequired,
  isAuthenticated: PropTypes.bool.isRequired,
  renderHSMonthlyBill: PropTypes.func.isRequired,
  renderMobilityMonthlyBill: PropTypes.func.isRequired,
  dataTestId: PropTypes.string.isRequired,
  cart: PropTypes.object.isRequired,
  Actions: PropTypes.node
}

PaymentBreakdownSection.defaultProps = {
  Actions: undefined
}

export default PaymentBreakdownSection
